import { z } from "zod";

import { systemFields, zMedia } from "@/lib/zod/show-fragments";

/** Read-only view schema for the Teams show page — full TeamDbDto. */
export const teamViewSchema = z
  .object({
    id: z.string(),
    name: z.string().nullish(),
    shortName: z.string().nullish(),
    slug: z.string().nullish(),
    sport: z.string().nullish(),
    country: z.string().nullish(),
    city: z.string().nullish(),
    gender: z.string().nullish(),
    homeVenueId: z.string().nullish(),
    foundedYear: z.number().nullish(),
    nicknames: z.record(z.string(), z.string()).nullish(),
    wikidataId: z.string().nullish(),
    status: z.string().nullish(),
    hide: z.boolean().nullish(),
    media: zMedia.nullish(),
    metadata: z
      .object({
        source: z.string().nullish(),
        sourceId: z.string().nullish(),
      })
      .passthrough()
      .nullish(),
    ...systemFields,
  })
  .passthrough();

export type TeamViewType = z.infer<typeof teamViewSchema>;
